import { Flex, Icon, Text, Button, useColorModeValue } from '@chakra-ui/react';
import { MdErrorOutline } from 'react-icons/md';
import FadeIn from 'components/animations/FadeIn';

interface ErrorStateProps {
	message?: string;
	onRetry?: () => void;
}

export default function ErrorState({
	message = 'Something went wrong. Please try again.',
	onRetry,
}: ErrorStateProps) {
	const titleColor = useColorModeValue('secondaryGray.900', 'white');
	const descColor = useColorModeValue('secondaryGray.600', 'secondaryGray.500');

	return (
		<FadeIn>
			<Flex
				direction='column'
				align='center'
				justify='center'
				py='60px'
				px='20px'
			>
				<Flex
					align='center'
					justify='center'
					w='80px'
					h='80px'
					borderRadius='50%'
					bg={useColorModeValue('danger.50', 'rgba(238, 93, 80, 0.1)')}
					mb='20px'
				>
					<Icon as={MdErrorOutline} w='36px' h='36px' color='danger.500' />
				</Flex>
				<Text
					color={titleColor}
					fontSize='lg'
					fontWeight='700'
					mb='8px'
					textAlign='center'
				>
					Error
				</Text>
				<Text
					color={descColor}
					fontSize='sm'
					fontWeight='400'
					textAlign='center'
					maxW='360px'
					mb={onRetry ? '20px' : '0px'}
				>
					{message}
				</Text>
				{onRetry && (
					<Button variant='brand' size='md' onClick={onRetry}>
						Retry
					</Button>
				)}
			</Flex>
		</FadeIn>
	);
}
